import React from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import IconReusable from '../../../components/IconReusable';


const QuantityHandler = ({
  value,
  onIncrease,
  onDecrease,
  onChange,
  onBlur,
  onKeyPress,
  variant = 'medium',
  disabled = false,
  min = 0,
  increaseDisabled = false,
  onIncreaseAttempt,
}) => {
  const isSmall = variant === 'small';
  
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^(\d{1,3}|\d{0,3}\.\d{0,3})$/.test(value)) {
      if (onChange) onChange(event);
    }
  };
  
  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: isSmall ? 1 : 2,
      px: isSmall ? '0px' : '2px',
      justifyContent: 'space-between',
      width: '100%',
    },
    iconButton: {
        p: 0
    },
    textField: {
        width: `${Math.max(2, value.toString().length) * (isSmall ? 8 : 10)}px`,
        '& .MuiInput-underline:before': { borderBottom: 'none' },
        '& .MuiInput-underline:after': { borderBottom: 'none' },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
    },
    input: {
      textAlign: 'center',
    }
  };

  return (
    <Box sx={{ 
        border: '1px solid #ccc',
        borderRadius: 1, 
        height: isSmall ? '32px' : '40px', 
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'center',
        p: isSmall ? 0.5 : 1,    
        minWidth: isSmall ? '110px' : '165px',
    }}>
        <Box sx={styles.container}>
        <IconButton
            size={isSmall ? '16px' : '24px'}
            onClick={onDecrease}
            disabled={disabled || parseFloat(value) <= min}
            sx={styles.iconButton}
        >
            <IconReusable name='Minus' size={ isSmall ? '16px' : '24px'} />
        </IconButton>
        <TextField
            value={value}
            onChange={handleInputChange}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
            variant="standard"
            disabled={disabled}
            inputProps={{
            style: styles.input,
                min: min,
                step: 0.001
            }}
            sx={styles.textField}
        />
        <IconButton
            size={ isSmall ? '16px' : '24px'}
            onClick={(e) => {
                if (disabled || increaseDisabled) {
                    // Call onIncreaseAttempt when trying to click disabled button
                    if (onIncreaseAttempt) onIncreaseAttempt();
                } else {
                    if (onIncrease) onIncrease();
                }
            }}
            sx={{
                ...styles.iconButton,
                opacity: (disabled || increaseDisabled) ? 0.5 : 1,
                cursor: (disabled || increaseDisabled) ? 'not-allowed' : 'pointer'
            }}
        >
            <IconReusable name='Add' size={ isSmall ? '16px' : '24px'} />
        </IconButton>
        </Box>
    </Box>
  );
};

export default QuantityHandler;
